export default {
  title: 'Mobile Mode Not Supported',
  message: 'Currently, the Astrochingolo application is optimized only for desktop devices. The mobile version is under development.',
  message2: 'For a better experience, we recommend accessing from a computer or device with a larger screen.',
  button: 'Understood'
}
